const $ = global.jQuery = require("jquery");

module.exports = function (scope,err) {

    console.error(scope,err);

    let heading,message;

    switch (scope) {

        case 'ie':
            heading = "Internet Explorer is no longer supported.";
            message = "Please open GoodDay using  <strong>Edge, Chrome, Firefox, Opera</strong> or any other modern browser. ";
            break;

        case 'local-settings-not-available':
            heading = "Local Settings disabled";
            message = "Your browser does not support local settings which are required to run GoodDay. Most likely you are using <strong>Safari in private(incognito)</strong> mode which disables local settings. ";
            break;

        case 'session-settings-not-available':
            heading = "Session Settings disabled";
            message = "Your browser does not support session settings which are required to run GoodDay. Most likely you are using <strong>Safari in private(incognito)</strong> mode which disables local settings. ";
            break;

        default:
            heading = "Unknown system error.";
            message = "Oops... Something went wrong. Please refresh and try again. If you see this message again try different browser or contact support.";
            break;
    }

    epicFail(heading, message, err);
};